// extracted by mini-css-extract-plugin
export var gif = "_ke-0";